import { render, staticRenderFns } from "./tkaddcon.vue?vue&type=template&id=827c5614&"
import script from "./tkaddcon.vue?vue&type=script&lang=js&"
export * from "./tkaddcon.vue?vue&type=script&lang=js&"
import style0 from "./tkaddcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports